
import { mapGetters } from 'vuex'
import { formatter } from '@/plugins/date'
export default {
  props: {
    item: {
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      getCustomerPackages: 'seances/getCustomerPackages',
    }),
    getPurchasedPackages() {
      if (this.item.Processes === 0) return []
      return (
        this.getCustomerPackages.filter(
          (c) =>
            c.isPurchased &&
            c.ProcessesData.find((p) => p.Id === this.item.Processes[0].Id) &&
            c.remainCount > 0
        ) || []
      )
    },
  },
  methods: {
    formatter,
    JOIN_ARRAY(arr) {
      return arr.map((a) => a.Name).join(', ')
    },
  },
}
